export function getQueryParams(options?: Record<string, unknown>) {
	const queryParams = new URLSearchParams();

	Object.keys(options || {}).forEach((key) => {
		queryParams.append(key, String(options?.[key]));
	});

	return queryParams.toString();
}
